import type { API } from 'chessboard/api/config/types';
import { Game } from 'chessboard/model/game/types';
import { Core } from 'chessboard/core/config/types';
import { MoveList } from 'chessboard/model/move-list/types';

/**
 * Create the agreeDraw method.
 */
export function createAgreeDraw(context: API.Context) {
  /**
   * Agree a draw between the two players.
   */
  return function agreeDraw(): API.Response {
    const { api, respond } = context;

    if (api.isGameOver()) {
      return null;
    }

    const Result = Game.Results.Draw;
    const Termination = MoveList.Translation.GameTerminationMessages.DrawByAgreement;

    api.setGameDetails({ Result, Termination });

    return respond(Core.APIEvents.DrawAgreed);
  };
}
